//
// Variable.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../../moduleBuilder";
import EventDispatcher from "../../../events/EventDispatcher";
import "../../../lib";
import "./DataType";
import "./StatisticType";

var Variable = createModule("commons::Variable", [], EventDispatcher, [
    ,
    ,
    ,
    {
        dataType: 4,
        name: 7,
        formatName: 7,
        aggregation: 4,
        label: 7,
    },
    {
        isNumber: [2],
        isDateTime: [2],
        isString: [2],
        description: [7],
    },
    {
        _create: [4],
    },
    ,
]);
export default Variable;
